<template>
    <fullscreen class="fullscreen" ref="fullscreen" @change="fullscreenChange">
        <button class="button-adjust" type="button" @click="toggle"><i :class="buttonClass"></i></button>
        <div class="pagecenter">
            <div class="pagecenterdetails">
                <div class="ticket-counter-wrapper full-screen-mode">
                    <div class="ticket-counter">
                        <div class="top-title">
                            <div class="logo">
                                <img src="static/images/vvg-logo-white.png" alt="Velocity Vehicle Group">
                            </div>
                            <div class="page-title">{{pageTitle}}</div> 
                            <span class="current-time">{{currentTime}}</span> 
                        </div>
                        <div class="middle-content container-fluid">
                            <div class="row">
                                <div class="col-md-6 col-sm-6 form-group">
                                    <div class="section-box box-1">
                                        <div class="box-wrapper">
                                            <div class="title">{{frontCounterTitle}}</div>
                                            <div class="sub-title">{{todayAvgLabel}}</div>
                                            <div class="minutes">{{frontCounterAvgWaitTime}}</div>
                                            <div class="min-text">{{minutesLabel}}</div>
                                        </div>
                                        <div class="information">{{weekAvgLabel}} <br/> <span>{{frontCounterWeekAvgTime}}</span></div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 form-group">
                                    <div class="section-box box-2">
                                        <div class="box-wrapper">
                                            <div class="title">{{willCallTitle}}</div>
                                            <div class="sub-title">{{todayAvgLabel}}</div>
                                            <div class="minutes">{{willCallAvgWaitTime}}</div>
                                            <div class="min-text">{{minutesLabel}}</div>
                                        </div>
                                        <div class="information">{{weekAvgLabel}} <br/> <span>{{willCallWeekAvgTime}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-title"><img class="icon-left" src="static/images/ticket_arrow.png"/> <span> Take a Number Below </span><img class="icon-right" src="static/images/ticket_arrow.png"/></div>
                    </div>
                </div> 
                
            </div>
        </div>
    </fullscreen>
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import {commonMixins} from '../mixins/commonMixins';
    import EventBus from "./event-bus";
    import moment from 'moment';
    import fullscreen from 'vue-fullscreen';
    var evtSource = false;

    Vue.use(fullscreen);
    export default {
        name: "TicketWaitingWindow",
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
        },
        data() {
            return {
                locationName : '',
                closedTicketNumber : '',
                locationId : '',
                locationData: {
                    location_id: 0,
                },
                isWillCall: false,

                buttonClass : "fa fa-expand",
                fullscreen: false,
                pageTitle : 'wait times',
                frontCounterTitle : 'front counter',
                willCallTitle : 'will call',
                todayAvgLabel : "today's average",
                weekAvgLabel : "this week's average time",
                minutesLabel : 'minutes',
                currentTime : '',
                frontCounterLocationId : '',
                willCallLocationId : '',
                frontCounterAvgWaitTime : '',
                willCallAvgWaitTime : '',
                frontCounterWeekAvgTime : '',
                willCallWeekAvgTime : '',
                browserTimeZone : ""
            }
        },

        mounted:function(){
            // Hide top navigation and sidebar view
            $(".navbar.navbar-default.no-margin.app-sidebar-nav").hide();
            $(".app-sidebar-right").addClass('toggled-2');
            $("#sidebar-wrapper").hide();

            let self = this;
            
            self.getCurrentTime();
            self.loadWaitingWindowData();
        },
        methods: {
            toggle () {
                this.$fullscreen.toggle(this.$el.querySelector('.pagecenter'), {
                    wrap: true,
                    callback: this.fullscreenChange
                })
            },
            fullscreenChange (fullscreen) {
                this.fullscreen = fullscreen;
                if (fullscreen == true) {
                    this.buttonClass = "fa fa-compress";
                    $('.pagecenter').addClass('wait-time-block');
                } else {
                    this.buttonClass = "fa fa-expand";
                    $('.pagecenter').removeClass('wait-time-block');
                }
            },
            getCurrentTime() {
                let self= this;
                let btz = localStorage.getItem("browserTimeZone");
                if (btz == null || btz == '' || typeof btz === "undefined") {
                    self.browserTimeZone = moment.tz.guess();
                    window.localStorage.setItem('browserTimeZone', self.browserTimeZone);
                    btz = localStorage.getItem("browserTimeZone");
                }
                self.currentTime =  moment().tz(btz).format('h:mm A'); // 12 hrs Format

                setTimeout(self.getCurrentTime, 60*1000); // Recursive Call
            },
            loadWaitingWindowData() {
                let self= this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params: { 
                        // 'browserTimezone': localStorage.getItem("browserTimeZone"),
                        'front_counter_location_id': localStorage.getItem("front_counter_location_id"),
                        'will_call_location_id': localStorage.getItem("will_call_location_id"),
                    }
                };
                HTTP.get('/ticket/waitTime',config)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            // Today's Avg Wait Time
                           self.frontCounterAvgWaitTime = response.data.content.frontCounterTodayAvgWaitTime;
                           self.willCallAvgWaitTime = response.data.content.willCallTodayAvgWaitTime;
                            // Week Avg Wait Time
                           self.frontCounterWeekAvgTime = response.data.content.frontCounterWeekAvgTime;
                           self.willCallWeekAvgTime = response.data.content.willCallWeekAvgTime;
                        }
                        setTimeout(self.loadWaitingWindowData, 60*1000); 
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
        }
    }
    // stop event source
    EventBus.$on('logout-user-stop-event-source', function () {
        if (evtSource !== false) {
            evtSource.close();
        }
    });
</script>

<style>
    /*fonts*/
    @font-face {
        font-family: 'SanFranciscoDisplayRegular';
        src: url("../../static/fonts/SanFranciscoDisplayRegular.eot");
        src: url("../../static/fonts/SanFranciscoDisplayRegular.eot?#iefix") format("embedded-opentype"),
        url("../../static/fonts/SanFranciscoDisplayRegular.woff2") format("woff2"),
        url("../../static/fonts/SanFranciscoDisplayRegular.woff") format("woff"),
        url("../../static/fonts/SanFranciscoDisplayRegular.ttf") format("truetype");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'SanFranciscoDisplayBold';
        src: url("../../static/fonts/SanFranciscoDisplayBold.eot");
        src: url("../../static/fonts/SanFranciscoDisplayBold.eot?#iefix") format("embedded-opentype"), url("../../static/fonts/SanFranciscoDisplayBold.woff2") format("woff2"), url("../../static/fonts/SanFranciscoDisplayBold.woff") format("woff"), url("../../static/fonts/SanFranciscoDisplayBold.ttf") format("truetype");
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'SanFranciscoDisplayThin';
        src: url("../../static/fonts/SanFranciscoDisplayThin.eot");
        src: url("../../static/fonts/SanFranciscoDisplayThin.eot") format("embedded-opentype"), url("../../static/fonts/SanFranciscoDisplayThin.woff2") format("woff2"), url("../../static/fonts/SanFranciscoDisplayThin.woff") format("woff"), url("../../static/fonts/SanFranciscoDisplayThin.ttf") format("truetype"), url("../../static/fonts/SanFranciscoDisplayThin.svg#SanFranciscoDisplayThin") format("svg");
    }
    /*fonts*/

    body {
        float: left;
        width: 100%;
        padding:0;
        background: #f5f5f5;
        margin: 0;
        text-align: center;


    }
    .ticket-counter-wrapper {
        float: none;
        width: 90%;
        background: #fff;
        /* padding: 40px; */
        -webkit-box-shadow: 0 0 7px 1px #ddd;
        box-shadow: 0 0 7px 1px #ddd;
        /*border: 1px solid #d3dee3;*/
        border-radius: 5px;
        text-align: center;
        font-weight: 300;
        margin-top: 50px;
        font-weight: bold;
        display: table;
        margin: 30px auto auto auto;
        text-align: center;
        /* height: 85vh; */
        line-height: normal;
    }
    .wait-time-block .ticket-counter-wrapper{
      margin: 0 !important;
      width: 100%;
    }
    .pagecenter{ width: 100%; display: table; text-align: center; padding: 0;  -ms-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%); position:fixed; top:50%;
        left:50%; height: 100vh;}
    .numberdetails , .pagecenterdetails{
        display: table-cell;
        vertical-align: middle;
    }
    .wait-time-block .pagecenterdetails{
      display: block !important;
      height: 100%;
    }
    .wait-time-block .ticket-counter-wrapper,
    .wait-time-block .ticket-counter {
      height: 100%;
    }
    .button-adjust {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 999;
        background: #0c1d43;
        border: 1px solid #0c1d43;
        color: #fff;
        border-radius: 5px;
        width: 35px;
        height: 35px;
    }

    /* Wait Time Screen - CSS */
    .ticket-counter {
        display: flex;
        flex-direction: column;
        height: 85vh;
    }
    .ticket-counter .top-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ticket-counter .top-title .logo img{
        height: 35px;
        /* filter: brightness(0) invert(1); */  
    }
    .ticket-counter .top-title,
    .ticket-counter .bottom-title{
        background-color: #132953;
        text-align: center;
        padding: 10px;
        font-size: 35px;
        text-transform: uppercase;
        color: #fff;
        font-weight: bold;
    }
    .ticket-counter .current-time{
        float:right;
        font-size: 16px;
        padding-top: 11px;
    }
    .ticket-counter .bottom-title{
        text-transform: none;
        letter-spacing: 2px;
    }
    .ticket-counter .bottom-title .icon-left{
        padding-right: 70px;
    }
    .ticket-counter .bottom-title .icon-right{
        padding-left: 70px;
    }
    .ticket-counter .middle-content{
        padding: 30px 10px;
        text-align: center;
        background-color: #19548d;
        flex:1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .full-screen-mode .middle-content {
        background-color: #fff;
        display: block;
        padding: 0 10px 50px;
    }
    .ticket-counter .middle-content .row{
        height:100%;
    }
    .full-screen-mode .middle-content .row{
        justify-content: space-between;
    }
    .ticket-counter .middle-content .box-wrapper{
        border: 2px solid #fff;
        /* padding: 80px; */
        color: #fff;
        text-transform: uppercase;
        height:100%;;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .full-screen-mode .middle-content .box-wrapper {
      border: none;
      color: #0c1d43;
    }
    .ticket-counter .middle-content .section-box .title{
        font-weight: bold;
        font-size: 35px;
        margin-bottom: 20px;
    }
    .full-screen-mode .middle-content .section-box .title{
        font-size: 60px;
    }
    .ticket-counter .middle-content .section-box .sub-title{
        font-weight: 600;
        margin-bottom: 15px;
        font-size: 23px;
    }
    .full-screen-mode .middle-content .section-box .sub-title{
        font-size: 32px;
    }
    .ticket-counter .middle-content .section-box .minutes{
        font-size: 70px;
        font-weight: bold;
        line-height: 60px;
        margin-bottom: 20px;
        letter-spacing: 4px;
    }
    .full-screen-mode .middle-content .section-box .minutes{
        font-size: 240px;
        line-height: 240px;
    }
    .ticket-counter .middle-content .section-box .min-text{
        font-size: 24px;
        font-weight: bold;
        letter-spacing: 2px;
    }
    .full-screen-mode .middle-content .section-box .min-text{
        font-size: 32px;
    }
    .ticket-counter .middle-content .section-box .information{
        color: #fff;
        line-height: 21px;
        margin-top: 10px;
        text-transform: uppercase;
        font-size: 22px;
    }
    .full-screen-mode .middle-content .section-box .information{
        color: #0c1d43;
        margin-top: 0px;
        font-size: 28px;
        line-height: 30px;
    }
    /* Full Screen - CSS */
    .fullscreen {
        background: whitesmoke;
    }
    .button-adjust {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 999;
        background: #0c1d43;
        border: 1px solid #0c1d43;
        color: #fff;
        border-radius: 5px;
        width: 35px;
        height: 35px;
    }
    /* Full Screen - CSS */
    .ticket-counter .top-title .page-title {
        margin-left: -102px;
    }
    @media (max-width: 1688px) {
      .full-screen-mode .middle-content .section-box .minutes{
          font-size: 165px;
      }
    }
    @media (min-width: 1301px) {
        .ticket-counter .middle-content .section-box{
            width: 600px;
            height:100%;
            /* padding: 150px 50px; */
            padding: 100px 50px;
        }
        .ticket-counter .middle-content .section-box.box-1{
            float: right;
            /* margin-right: 20px; */
        }
        .full-screen-mode .middle-content .section-box{
            padding: 50px 50px;
            float: none;
            margin: 0 auto;
            width: auto;
        }
    }
    @media (max-width: 1300px) {
        .ticket-counter .middle-content .section-box{
            height: 100%;
            padding: 80px 30px;
            width:400px;
        }
        .full-screen-mode .middle-content .section-box{
            padding: 50px 30px;
            float: none;
            margin: 0 auto;
            width: auto;
        }
        .ticket-counter .top-title .page-title {
            margin-left: -50px;
        }
        .ticket-counter .bottom-title span{
            line-height: 32px;
            font-size: 26px;
        }
        .ticket-counter .bottom-title .icon-left{
            padding-right: 20px;
        }
        .ticket-counter .bottom-title .icon-right{
            padding-left: 20px;
        }
        .ticket-counter .top-title, .ticket-counter .bottom-title{
            font-size: 15px;
        }
        .ticket-counter .top-title .logo{
            width:auto;
        }
        .ticket-counter .top-title .logo img{
            width: auto;
            height: 25px;
        }
        .ticket-counter .current-time{
            padding-top: 0;
            font-size: 16px !important;
        }
        .ticket-counter .middle-content .box-wrapper{
            padding:10px;
        }
        .ticket-counter .middle-content .section-box .title,
        .ticket-counter .middle-content .section-box .min-text{
            font-size: 20px;
        }
        .full-screen-mode .middle-content .section-box .title,
        .full-screen-mode .middle-content .section-box .min-text{
            font-size: 30px;
        }
        .ticket-counter .middle-content .section-box .minutes{
            font-size: 35px;
            margin-bottom: 10px;
        }
        .full-screen-mode .middle-content .section-box .minutes{
            font-size: 117px;
        }
        .ticket-counter .middle-content .section-box .sub-title{
            margin-bottom: 10px;
            font-size: 20px;
        }
        .full-screen-mode .middle-content .section-box .sub-title{
          font-size: 25px;
        }
        .ticket-counter .middle-content .section-box .information,
        .ticket-counter .middle-content .section-box .information span{
            font-size: 18px !important;
        }
        .full-screen-mode .middle-content .section-box .information,
        .full-screen-mode .middle-content .section-box .information span{
          font-size: 22px !important;
        }
    }
    @media (max-width: 945px) {
        .ticket-counter .middle-content .section-box{
            height: 100%;
            padding: 80px 0;
            width:auto;
        }
        .full-screen-mode .middle-content .section-box .minutes {
            font-size: 60px;
            line-height: 60px;
        }
        .full-screen-mode .middle-content .section-box .information, .full-screen-mode .middle-content .section-box .information span {
          font-size: 18px !important;
        }
    }
    @media (max-width: 767px) {
        .pagecenter{
            position:unset;
            transform: none;
        }
        .ticket-counter .top-title .page-title {
            margin-left: 0;
        }
    }
    @media (max-width: 575px) {
        .ticket-counter .middle-content .section-box{
            height: auto;
            padding: 0;
        }
    }
    @media (max-width: 519px) {
        .ticket-counter .bottom-title span{
            display: block;
        }
        .ticket-counter .bottom-title .icon-left{
            display: none;
        }
        .ticket-counter .bottom-title .icon-right{
            padding: 0;
        }
    }
    /* Wait Time Screen - CSS */

</style>



// WEBPACK FOOTER //
// src/components/TicketWaitingWindow.vue